import React, { forwardRef } from 'react'
import { useDrag } from 'react-dnd'
import { Tag } from 'antd'
import cl from 'classnames'

import { Icon } from 'Shared/atoms'

import { ITEM_TYPE } from '../types'

import { DraggableItemProps } from './types'

import styles from './styles.module.scss'

const DraggableItem = forwardRef<HTMLSpanElement, DraggableItemProps>(
	({ label, value, onClose, potentialDropTarget, resetPotentialDropTarget }, ref) => {
		const [{ isDragging }, drag] = useDrag({
			type: ITEM_TYPE,
			item: { label, value: value as number },
			collect: (monitor) => ({
				isDragging: !!monitor.isDragging()
			}),
			end: (item, monitor) => {
				if (!monitor.didDrop()) {
					resetPotentialDropTarget()
				}
			}
		})

		const onPreventMouseDown = (e: React.MouseEvent<HTMLSpanElement>) => {
			e.stopPropagation()
		}

		return (
			<div
				ref={drag}
				className={cl(styles.tagWrapper, {
					[styles.isBeforeDropTarget]:
						value.toString() === potentialDropTarget?.dropTarget &&
						potentialDropTarget?.isBefore,
					[styles.isAfterDropTarget]:
						value.toString() === potentialDropTarget?.dropTarget &&
						potentialDropTarget?.isAfter,
					[styles.isDragging]: isDragging
				})}
			>
				<Tag
					ref={ref}
					closable
					onClose={onClose}
					onMouseDown={onPreventMouseDown}
					className={styles.draggableItem}
				>
					<Icon
						type="dragSource"
						className={cl(styles.dragIcon, { [styles.dragIconColored]: isDragging })}
					/>
					{label}
				</Tag>
			</div>
		)
	}
)

export default DraggableItem
